import { rest } from 'msw'
export default [
  /**
   * サービス一覧情報
   */
  rest.post('/api/v2/get_service_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          items: [
            {
              id: 3,
              title: 'TEST3',
              mainImage:
                'https://static-stg.retailstudio.jp/assets/services/3/service_img_3.jpg',
              listImageAttribute: {
                height: 640,
                width: 640,
              },
              detailImageAttribute: {
                height: 640,
                width: 640,
              },
              openDate: '1598886000',
              closeDate: '1604070000',
              details: null,
              referenceType: 'link',
              referenceLink:
                'https://www.hankyu-oasis.com/recipe/pickup/20200907-1.html',
            },
            {
              id: 2,
              title: 'TEST2',
              mainImage:
                'https://static-stg.retailstudio.jp/assets/services/2/service_img_2.jpg',
              listImageAttribute: {
                height: 640,
                width: 640,
              },
              detailImageAttribute: {
                height: 640,
                width: 640,
              },
              openDate: '1598886000',
              closeDate: '1604070000',
              details: null,
              referenceType: 'link',
              referenceLink:
                'https://www.hankyu-oasis.com/recipe/pickup/20200907-02.html',
            },
            {
              id: 1,
              title: 'TEST1',
              mainImage:
                'https://static-stg.retailstudio.jp/assets/services/1/service_img_1.jpg',
              listImageAttribute: {
                height: 640,
                width: 640,
              },
              detailImageAttribute: {
                height: 640,
                width: 640,
              },
              openDate: '1598886000',
              closeDate: '1604070000',
              details: null,
              referenceType: 'link',
              referenceLink:
                'https://www.hankyu-oasis.com/recipe/pickup/20200831-2.html',
            },
          ],
          count: 3,
          responseTime: 1603869648,
        },
      })
    )
  }),
]
